import type { PdfItem } from '../types/pdf';
import { request } from './pdfService';
import { apiUrl } from './api';

export interface HistoryItem { id: string; name: string; pages: number; libraryName: string; openedAt: string; openCount: number }
export interface OperationLog { id: string; level: string; action: string; message: string; details?: unknown; createdAt: string }
export const pdfManagerService = {
  list: async () => (await request<PdfItem[]>('/api/pdfs')).map((item) => ({ ...item, url: apiUrl(item.url), thumbnail: item.thumbnail ? apiUrl(item.thumbnail) : undefined })),
  rename: (id: string, name: string) => request<{ id: string; name: string }>(`/api/pdfs/${id}`, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name }) }),
  remove: (id: string) => request<void>(`/api/pdfs/${id}`, { method: 'DELETE' }),
  upload: (libraryId: string, file: File) => request<{ id: string; name: string }>(`/api/libraries/${libraryId}/pdfs`, { method: 'POST', headers: { 'Content-Type': 'application/pdf', 'X-File-Name': encodeURIComponent(file.name) }, body: file }),
  history: () => request<HistoryItem[]>('/api/history'),
  opened: (id: string) => request(`/api/history/${id}`, { method: 'POST' }),
  logs: () => request<OperationLog[]>('/api/logs?limit=50'),
};
